import { render, staticRenderFns } from "./TripleButton.vue?vue&type=template&id=19e073cb&scoped=true&"
import script from "./TripleButton.vue?vue&type=script&lang=js&"
export * from "./TripleButton.vue?vue&type=script&lang=js&"
import style0 from "./TripleButton.vue?vue&type=style&index=0&id=19e073cb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e073cb",
  null
  
)

export default component.exports